import { MigrationInterface, QueryRunner } from 'typeorm'

export class UserModifiableItemCategoryEntity1696851801610 implements MigrationInterface {
	name = 'UserModifiableItemCategoryEntity1696851801610'

	public async up(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "menu_item_category" ADD "createdBy" uuid`)
		await queryRunner.query(`ALTER TABLE "menu_item_category" ADD "lastUpdatedAt" TIMESTAMP NOT NULL DEFAULT now()`)
		await queryRunner.query(`ALTER TABLE "menu_item_category" ADD "lastUpdatedBy" uuid`)
	}

	public async down(queryRunner: QueryRunner): Promise<void> {
		await queryRunner.query(`ALTER TABLE "menu_item_category" DROP COLUMN "lastUpdatedBy"`)
		await queryRunner.query(`ALTER TABLE "menu_item_category" DROP COLUMN "lastUpdatedAt"`)
		await queryRunner.query(`ALTER TABLE "menu_item_category" DROP COLUMN "createdBy"`)
	}
}
